<script setup lang="ts">
// "Create with Orpheus" beside the new-alert form's step title (v3 `AlertModal.vue`, ORP-22826):
// switches to the Orpheus setup panel, carrying what the form holds so far.
import { useI18n } from '@/shared/i18n'

const emit = defineEmits<{ switch: [] }>()
const { t } = useI18n()
</script>

<template>
  <button
    type="button"
    class="inline-flex cursor-pointer items-center gap-2 rounded-full border border-orpheus-muted bg-surface px-3 py-1.5 text-sm font-semibold text-primary transition hover:bg-surface-sunken"
    data-testid="alert-wizard-create-with-orpheus"
    @click="emit('switch')"
  >
    <span class="h-1.5 w-1.5 rounded-full bg-orpheus-brand" aria-hidden="true" />
    {{ t('alerts.wizard.createWithOrpheus') }}
  </button>
</template>
